import { createFileRoute } from '@tanstack/react-router';
import BolSignatureGate from '@/components/bol-signature-gate';
import PaymentDetailsPage from '@/features/payment-details';

export const Route = createFileRoute('/_protected/payment-details/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <BolSignatureGate>
      <PaymentDetailsPage />
    </BolSignatureGate>
  );
}
